import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { ArrowLeft, ArrowUpRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { useServiceBySlug, useServiceItems } from '../hooks/useServiceItems';
import { isServiceSlug } from '../data/services';
import './ServiceDetailPage.css';

const ServiceDetailPage: React.FC = () => {
  const { slug = '' } = useParams();
  const { t } = useLanguage();
  const items = useServiceItems();
  const { service, index } = useServiceBySlug(slug);
  const next = items[(index + 1) % items.length];

  if (!isServiceSlug(slug) || !service || index < 0) {
    return <Navigate to="/services" replace />;
  }

  return (
    <div className="service-detail-page">
      <Link to="/services" className="service-detail-back">
        <ArrowLeft size={18} />
        {t.services.page.backToList}
      </Link>

      <header className="service-detail-header">
        <p className="service-detail-label">{t.services.page.serviceLabel}</p>
        <p className="service-detail-meta">{service.meta}</p>
        <h1 className="service-detail-title">{service.title}</h1>
        <p className="service-detail-tagline">{service.tagline}</p>
      </header>

      <div className="service-detail-body">
        <p>{service.body}</p>
      </div>

      <section className="service-detail-deliverables">
        <h2>{t.services.page.deliverables}</h2>
        <ul>
          {service.highlights.map((item, highlightIndex) => (
            <li key={highlightIndex}>{item}</li>
          ))}
        </ul>
      </section>

      <div className="service-detail-cta">
        <Link to={{ pathname: '/', hash: 'contact' }} className="btn btn-primary service-detail-cta-btn">
          {t.services.page.startProject}
        </Link>
      </div>

      {next && next.slug !== slug && (
        <Link to={`/services/${next.slug}`} className="service-detail-next">
          <div>
            <span className="service-detail-next-label">{t.services.page.nextService}</span>
            <span className="service-detail-next-meta">{next.meta}</span>
            <span className="service-detail-next-title">{next.title}</span>
          </div>
          <span className="service-detail-next-action">
            {t.services.page.openService}
            <ArrowUpRight size={20} />
          </span>
        </Link>
      )}
    </div>
  );
};

export default ServiceDetailPage;
